// Curated scanner ticker universe with company names.
export const SYMBOL_DATA = [
  // ETFs
  { symbol: "SPY", name: "SPDR S&P 500 ETF Trust" },
  { symbol: "QQQ", name: "Invesco QQQ Trust" },
  
  // Companies A-Z
  { symbol: "AAPL", name: "Apple Inc." },
  { symbol: "ABBV", name: "AbbVie Inc." },
  { symbol: "ABT", name: "Abbott Laboratories" },
  { symbol: "ACN", name: "Accenture plc" },
  { symbol: "ADBE", name: "Adobe Inc." },
  { symbol: "ADI", name: "Analog Devices Inc." },
  { symbol: "ADM", name: "Archer-Daniels-Midland Company" },
  { symbol: "ADP", name: "Automatic Data Processing Inc." },
  { symbol: "ADSK", name: "Autodesk Inc." },
  { symbol: "AEE", name: "Ameren Corporation" },
  { symbol: "AEP", name: "American Electric Power Company Inc." },
  { symbol: "AES", name: "AES Corporation" },
  { symbol: "AFL", name: "Aflac Incorporated" },
  { symbol: "AIG", name: "American International Group Inc." },
  { symbol: "AIZ", name: "Assurant Inc." },
  { symbol: "AJG", name: "Arthur J. Gallagher & Co." },
  { symbol: "AKAM", name: "Akamai Technologies Inc." },
  { symbol: "ALB", name: "Albemarle Corporation" },
  { symbol: "ALGN", name: "Align Technology Inc." },
  { symbol: "ALL", name: "Allstate Corporation" },
  { symbol: "ALLE", name: "Allegion plc" },
  { symbol: "AMAT", name: "Applied Materials Inc." },
  { symbol: "AMCR", name: "Amcor plc" },
  { symbol: "AMD", name: "Advanced Micro Devices Inc." },
  { symbol: "AME", name: "AMETEK Inc." },
  { symbol: "AMGN", name: "Amgen Inc." },
  { symbol: "AMP", name: "Ameriprise Financial Inc." },
  { symbol: "AMT", name: "American Tower Corporation" },
  { symbol: "AMZN", name: "Amazon.com Inc." },
  { symbol: "ANET", name: "Arista Networks Inc." },
  { symbol: "AON", name: "Aon plc" },
  { symbol: "AOS", name: "A. O. Smith Corporation" },
  { symbol: "APA", name: "APA Corporation" },
  { symbol: "APD", name: "Air Products and Chemicals Inc." },
  { symbol: "APH", name: "Amphenol Corporation" },
  { symbol: "APTV", name: "Aptiv PLC" },
  { symbol: "ARE", name: "Alexandria Real Estate Equities Inc." },
  { symbol: "ATO", name: "Atmos Energy Corporation" },
  { symbol: "AVGO", name: "Broadcom Inc." },
  { symbol: "AVY", name: "Avery Dennison Corporation" },
  { symbol: "AWK", name: "American Water Works Company Inc." },
  { symbol: "AXON", name: "Axon Enterprise Inc." },
  { symbol: "AXP", name: "American Express Company" },
  { symbol: "AZO", name: "AutoZone Inc." },
  { symbol: "BA", name: "Boeing Company" },
  { symbol: "BAC", name: "Bank of America Corporation" },
  { symbol: "BALL", name: "Ball Corporation" },
  { symbol: "BAX", name: "Baxter International Inc." },
  { symbol: "BBWI", name: "Bath & Body Works Inc." },
  { symbol: "BBY", name: "Best Buy Co. Inc." },
  { symbol: "BDX", name: "Becton Dickinson and Company" },
  { symbol: "BEN", name: "Franklin Resources Inc." },
  { symbol: "BF-B", name: "Brown-Forman Corporation Class B" },
  { symbol: "BIIB", name: "Biogen Inc." },
  { symbol: "BIO", name: "Bio-Rad Laboratories Inc." },
  { symbol: "BKNG", name: "Booking Holdings Inc." },
  { symbol: "BKR", name: "Baker Hughes Company" },
  { symbol: "BLDR", name: "Builders FirstSource Inc." },
  { symbol: "BLK", name: "BlackRock Inc." },
  { symbol: "BMY", name: "Bristol-Myers Squibb Company" },
  { symbol: "BNY", name: "Bank of New York Mellon Corporation" },
  { symbol: "BR", name: "Broadridge Financial Solutions Inc." },
  { symbol: "BRK-B", name: "Berkshire Hathaway Inc. Class B" },
  { symbol: "BRO", name: "Brown & Brown Inc." },
  { symbol: "BSX", name: "Boston Scientific Corporation" },
  { symbol: "BWA", name: "BorgWarner Inc." },
  { symbol: "BX", name: "Blackstone Inc." },
  { symbol: "BXP", name: "BXP Inc." },
  { symbol: "C", name: "Citigroup Inc." },
  { symbol: "CAG", name: "Conagra Brands Inc." },
  { symbol: "CAH", name: "Cardinal Health Inc." },
  { symbol: "CARR", name: "Carrier Global Corporation" },
  { symbol: "CAT", name: "Caterpillar Inc." },
  { symbol: "CB", name: "Chubb Limited" },
  { symbol: "CBOE", name: "Cboe Global Markets Inc." },
  { symbol: "CBRE", name: "CBRE Group Inc." },
  { symbol: "CCI", name: "Crown Castle Inc." },
  { symbol: "CCL", name: "Carnival Corporation" },
  { symbol: "CDNS", name: "Cadence Design Systems Inc." },
  { symbol: "CDW", name: "CDW Corporation" },
  { symbol: "CE", name: "Celanese Corporation" },
  { symbol: "CEG", name: "Constellation Energy Corporation" },
  { symbol: "CF", name: "CF Industries Holdings Inc." },
  { symbol: "CFG", name: "Citizens Financial Group Inc." },
  { symbol: "CHD", name: "Church & Dwight Co. Inc." },
  { symbol: "CHRW", name: "C.H. Robinson Worldwide Inc." },
  { symbol: "CHTR", name: "Charter Communications Inc." },
  { symbol: "CI", name: "Cigna Group" },
  { symbol: "CINF", name: "Cincinnati Financial Corporation" },
  { symbol: "CL", name: "Colgate-Palmolive Company" },
  { symbol: "CLX", name: "Clorox Company" },
  { symbol: "CMCSA", name: "Comcast Corporation" },
  { symbol: "CME", name: "CME Group Inc." },
  { symbol: "CMG", name: "Chipotle Mexican Grill Inc." },
  { symbol: "CMI", name: "Cummins Inc." },
  { symbol: "CMS", name: "CMS Energy Corporation" },
  { symbol: "CNC", name: "Centene Corporation" },
  { symbol: "CNP", name: "CenterPoint Energy Inc." },
  { symbol: "COF", name: "Capital One Financial Corporation" },
  { symbol: "COO", name: "Cooper Companies Inc." },
  { symbol: "COP", name: "ConocoPhillips" },
  { symbol: "COR", name: "Cencora Inc." },
  { symbol: "COST", name: "Costco Wholesale Corporation" },
  { symbol: "CPAY", name: "Corpay Inc." },
  { symbol: "CPB", name: "Campbell Soup Company" },
  { symbol: "CPRT", name: "Copart Inc." },
  { symbol: "CPT", name: "Camden Property Trust" },
  { symbol: "CRL", name: "Charles River Laboratories International Inc." },
  { symbol: "CRM", name: "Salesforce Inc." },
  { symbol: "CSCO", name: "Cisco Systems Inc." },
  { symbol: "CSGP", name: "CoStar Group Inc." },
  { symbol: "CSX", name: "CSX Corporation" },
  { symbol: "CTAS", name: "Cintas Corporation" },
  { symbol: "CTSH", name: "Cognizant Technology Solutions Corporation" },
  { symbol: "CTVA", name: "Corteva Inc." },
  { symbol: "CVS", name: "CVS Health Corporation" },
  { symbol: "CVX", name: "Chevron Corporation" },
  { symbol: "CZR", name: "Caesars Entertainment Inc." },
  { symbol: "D", name: "Dominion Energy Inc." },
  { symbol: "DAL", name: "Delta Air Lines Inc." },
  { symbol: "DD", name: "DuPont de Nemours Inc." },
  { symbol: "DE", name: "Deere & Company" },
  { symbol: "DECK", name: "Deckers Outdoor Corporation" },
  { symbol: "DG", name: "Dollar General Corporation" },
  { symbol: "DGX", name: "Quest Diagnostics Incorporated" },
  { symbol: "DHI", name: "D.R. Horton Inc." },
  { symbol: "DHR", name: "Danaher Corporation" },
  { symbol: "DIS", name: "Walt Disney Company" },
  { symbol: "DLR", name: "Digital Realty Trust Inc." },
  { symbol: "DLTR", name: "Dollar Tree Inc." },
  { symbol: "DOC", name: "Healthpeak Properties Inc." },
  { symbol: "DOV", name: "Dover Corporation" },
  { symbol: "DOW", name: "Dow Inc." },
  { symbol: "DPZ", name: "Domino's Pizza Inc." },
  { symbol: "DRI", name: "Darden Restaurants Inc." },
  { symbol: "DTE", name: "DTE Energy Company" },
  { symbol: "DUK", name: "Duke Energy Corporation" },
  { symbol: "DVA", name: "DaVita Inc." },
  { symbol: "DVN", name: "Devon Energy Corporation" },
  { symbol: "DXCM", name: "DexCom Inc." },
  { symbol: "EBAY", name: "eBay Inc." },
  { symbol: "ECL", name: "Ecolab Inc." },
  { symbol: "ED", name: "Consolidated Edison Inc." },
  { symbol: "EFX", name: "Equifax Inc." },
  { symbol: "EG", name: "Everest Group Ltd." },
  { symbol: "EIX", name: "Edison International" },
  { symbol: "EL", name: "Estée Lauder Companies Inc." },
  { symbol: "ELV", name: "Elevance Health Inc." },
  { symbol: "EMN", name: "Eastman Chemical Company" },
  { symbol: "EMR", name: "Emerson Electric Co." },
  { symbol: "ENPH", name: "Enphase Energy Inc." },
  { symbol: "EOG", name: "EOG Resources Inc." },
  { symbol: "EPAM", name: "EPAM Systems Inc." },
  { symbol: "EQIX", name: "Equinix Inc." },
  { symbol: "EQT", name: "EQT Corporation" },
  { symbol: "ES", name: "Eversource Energy" },
  { symbol: "ESS", name: "Essex Property Trust Inc." },
  { symbol: "ETN", name: "Eaton Corporation plc" },
  { symbol: "ETR", name: "Entergy Corporation" },
  { symbol: "ETSY", name: "Etsy Inc." },
  { symbol: "EVRG", name: "Evergy Inc." },
  { symbol: "EW", name: "Edwards Lifesciences Corporation" },
  { symbol: "EXC", name: "Exelon Corporation" },
  { symbol: "EXPD", name: "Expeditors International of Washington Inc." },
  { symbol: "EXPE", name: "Expedia Group Inc." },
  { symbol: "EXR", name: "Extra Space Storage Inc." },
  { symbol: "F", name: "Ford Motor Company" },
  { symbol: "FANG", name: "Diamondback Energy Inc." },
  { symbol: "FAST", name: "Fastenal Company" },
  { symbol: "FCX", name: "Freeport-McMoRan Inc." },
  { symbol: "FDS", name: "FactSet Research Systems Inc." },
  { symbol: "FDX", name: "FedEx Corporation" },
  { symbol: "FE", name: "FirstEnergy Corp." },
  { symbol: "FFIV", name: "F5 Inc." },
  { symbol: "FICO", name: "Fair Isaac Corporation" },
  { symbol: "FIS", name: "Fidelity National Information Services Inc." },
  { symbol: "FISV", name: "Fiserv Inc." },
  { symbol: "FITB", name: "Fifth Third Bancorp" },
  { symbol: "FMC", name: "FMC Corporation" },
  { symbol: "FOX", name: "Fox Corporation Class B" },
  { symbol: "FOXA", name: "Fox Corporation Class A" },
  { symbol: "FRT", name: "Federal Realty Investment Trust" },
  { symbol: "FSLR", name: "First Solar Inc." },
  { symbol: "FTNT", name: "Fortinet Inc." },
  { symbol: "FTV", name: "Fortive Corporation" },
  { symbol: "GD", name: "General Dynamics Corporation" },
  { symbol: "GDDY", name: "GoDaddy Inc." },
  { symbol: "GE", name: "General Electric Company" },
  { symbol: "GEHC", name: "GE HealthCare Technologies Inc." },
  { symbol: "GEN", name: "Gen Digital Inc." },
  { symbol: "GEV", name: "GE Vernova Inc." },
  { symbol: "GILD", name: "Gilead Sciences Inc." },
  { symbol: "GIS", name: "General Mills Inc." },
  { symbol: "GL", name: "Globe Life Inc." },
  { symbol: "GLW", name: "Corning Incorporated" },
  { symbol: "GM", name: "General Motors Company" },
  { symbol: "GNRC", name: "Generac Holdings Inc." },
  { symbol: "GOOG", name: "Alphabet Inc. Class C" },
  { symbol: "GOOGL", name: "Alphabet Inc. Class A" },
  { symbol: "GPC", name: "Genuine Parts Company" },
  { symbol: "GPN", name: "Global Payments Inc." },
  { symbol: "GRMN", name: "Garmin Ltd." },
  { symbol: "GS", name: "Goldman Sachs Group Inc." },
  { symbol: "GWW", name: "W.W. Grainger Inc." },
  { symbol: "HAL", name: "Halliburton Company" },
  { symbol: "HAS", name: "Hasbro Inc." },
  { symbol: "HBAN", name: "Huntington Bancshares Incorporated" },
  { symbol: "HCA", name: "HCA Healthcare Inc." },
  { symbol: "HD", name: "Home Depot Inc." },
  { symbol: "HIG", name: "Hartford Financial Services Group Inc." },
  { symbol: "HII", name: "Huntington Ingalls Industries Inc." },
  { symbol: "HLT", name: "Hilton Worldwide Holdings Inc." },
  { symbol: "HON", name: "Honeywell International Inc." },
  { symbol: "HPE", name: "Hewlett Packard Enterprise Company" },
  { symbol: "HPQ", name: "HP Inc." },
  { symbol: "HRL", name: "Hormel Foods Corporation" },
  { symbol: "HSIC", name: "Henry Schein Inc." },
  { symbol: "HST", name: "Host Hotels & Resorts Inc." },
  { symbol: "HSY", name: "Hershey Company" },
  { symbol: "HUBB", name: "Hubbell Incorporated" },
  { symbol: "HUM", name: "Humana Inc." },
  { symbol: "HWM", name: "Howmet Aerospace Inc." },
  { symbol: "IBM", name: "International Business Machines Corporation" },
  { symbol: "ICE", name: "Intercontinental Exchange Inc." },
  { symbol: "IDXX", name: "IDEXX Laboratories Inc." },
  { symbol: "IEX", name: "IDEX Corporation" },
  { symbol: "IFF", name: "International Flavors & Fragrances Inc." },
  { symbol: "INCY", name: "Incyte Corporation" },
  { symbol: "INTC", name: "Intel Corporation" },
  { symbol: "INTU", name: "Intuit Inc." },
  { symbol: "INVH", name: "Invitation Homes Inc." },
  { symbol: "IP", name: "International Paper Company" },
  { symbol: "IQV", name: "IQVIA Holdings Inc." },
  { symbol: "IR", name: "Ingersoll Rand Inc." },
  { symbol: "IRM", name: "Iron Mountain Incorporated" },
  { symbol: "ISRG", name: "Intuitive Surgical Inc." },
  { symbol: "IT", name: "Gartner Inc." },
  { symbol: "ITW", name: "Illinois Tool Works Inc." },
  { symbol: "IVZ", name: "Invesco Ltd." },
  { symbol: "J", name: "Jacobs Solutions Inc." },
  { symbol: "JBHT", name: "J.B. Hunt Transport Services Inc." },
  { symbol: "JBL", name: "Jabil Inc." },
  { symbol: "JCI", name: "Johnson Controls International plc" },
  { symbol: "JKHY", name: "Jack Henry & Associates Inc." },
  { symbol: "JNJ", name: "Johnson & Johnson" },
  { symbol: "JPM", name: "JPMorgan Chase & Co." },
  { symbol: "KDP", name: "Keurig Dr Pepper Inc." },
  { symbol: "KEY", name: "KeyCorp" },
  { symbol: "KEYS", name: "Keysight Technologies Inc." },
  { symbol: "KHC", name: "Kraft Heinz Company" },
  { symbol: "KIM", name: "Kimco Realty Corporation" },
  { symbol: "KKR", name: "KKR & Co. Inc." },
  { symbol: "KLAC", name: "KLA Corporation" },
  { symbol: "KMB", name: "Kimberly-Clark Corporation" },
  { symbol: "KMI", name: "Kinder Morgan Inc." },
  { symbol: "KMX", name: "CarMax Inc." },
  { symbol: "KO", name: "Coca-Cola Company" },
  { symbol: "KR", name: "Kroger Co." },
  { symbol: "KVUE", name: "Kenvue Inc." },
  { symbol: "L", name: "Loews Corporation" },
  { symbol: "LDOS", name: "Leidos Holdings Inc." },
  { symbol: "LEN", name: "Lennar Corporation" },
  { symbol: "LH", name: "Laboratory Corporation of America Holdings" },
  { symbol: "LHX", name: "L3Harris Technologies Inc." },
  { symbol: "LIN", name: "Linde plc" },
  { symbol: "LKQ", name: "LKQ Corporation" },
  { symbol: "LLY", name: "Eli Lilly and Company" },
  { symbol: "LMT", name: "Lockheed Martin Corporation" },
  { symbol: "LNT", name: "Alliant Energy Corporation" },
  { symbol: "LOW", name: "Lowe's Companies Inc." },
  { symbol: "LRCX", name: "Lam Research Corporation" },
  { symbol: "LULU", name: "Lululemon Athletica Inc." },
  { symbol: "LUV", name: "Southwest Airlines Co." },
  { symbol: "LVS", name: "Las Vegas Sands Corp." },
  { symbol: "LW", name: "Lamb Weston Holdings Inc." },
  { symbol: "LYB", name: "LyondellBasell Industries N.V." },
  { symbol: "LYV", name: "Live Nation Entertainment Inc." },
  { symbol: "MA", name: "Mastercard Incorporated" },
  { symbol: "MAA", name: "Mid-America Apartment Communities Inc." },
  { symbol: "MAR", name: "Marriott International Inc." },
  { symbol: "MAS", name: "Masco Corporation" },
  { symbol: "MCD", name: "McDonald's Corporation" },
  { symbol: "MCHP", name: "Microchip Technology Incorporated" },
  { symbol: "MCK", name: "McKesson Corporation" },
  { symbol: "MCO", name: "Moody's Corporation" },
  { symbol: "MDLZ", name: "Mondelez International Inc." },
  { symbol: "MDT", name: "Medtronic plc" },
  { symbol: "MET", name: "MetLife Inc." },
  { symbol: "META", name: "Meta Platforms Inc." },
  { symbol: "MGM", name: "MGM Resorts International" },
  { symbol: "MHK", name: "Mohawk Industries Inc." },
  { symbol: "MKC", name: "McCormick & Company Incorporated" },
  { symbol: "MKTX", name: "MarketAxess Holdings Inc." },
  { symbol: "MLM", name: "Martin Marietta Materials Inc." },
  { symbol: "MMM", name: "3M Company" },
  { symbol: "MNST", name: "Monster Beverage Corporation" },
  { symbol: "MO", name: "Altria Group Inc." },
  { symbol: "MOH", name: "Molina Healthcare Inc." },
  { symbol: "MOS", name: "Mosaic Company" },
  { symbol: "MPC", name: "Marathon Petroleum Corporation" },
  { symbol: "MPWR", name: "Monolithic Power Systems Inc." },
  { symbol: "MRK", name: "Merck & Co. Inc." },
  { symbol: "MRNA", name: "Moderna Inc." },
  { symbol: "MRSH", name: "Marsh" },
  { symbol: "MS", name: "Morgan Stanley" },
  { symbol: "MSCI", name: "MSCI Inc." },
  { symbol: "MSFT", name: "Microsoft Corporation" },
  { symbol: "MSI", name: "Motorola Solutions Inc." },
  { symbol: "MTB", name: "M&T Bank Corporation" },
  { symbol: "MTCH", name: "Match Group Inc." },
  { symbol: "MTD", name: "Mettler-Toledo International Inc." },
  { symbol: "MU", name: "Micron Technology Inc." },
  { symbol: "NCLH", name: "Norwegian Cruise Line Holdings Ltd." },
  { symbol: "NDAQ", name: "Nasdaq Inc." },
  { symbol: "NDSN", name: "Nordson Corporation" },
  { symbol: "NEE", name: "NextEra Energy Inc." },
  { symbol: "NEM", name: "Newmont Corporation" },
  { symbol: "NFLX", name: "Netflix Inc." },
  { symbol: "NI", name: "NiSource Inc." },
  { symbol: "NKE", name: "Nike Inc." },
  { symbol: "NOC", name: "Northrop Grumman Corporation" },
  { symbol: "NOW", name: "ServiceNow Inc." },
  { symbol: "NRG", name: "NRG Energy Inc." },
  { symbol: "NSC", name: "Norfolk Southern Corporation" },
  { symbol: "NTAP", name: "NetApp Inc." },
  { symbol: "NTRS", name: "Northern Trust Corporation" },
  { symbol: "NUE", name: "Nucor Corporation" },
  { symbol: "NVDA", name: "NVIDIA Corporation" },
  { symbol: "NVR", name: "NVR Inc." },
  { symbol: "NWS", name: "News Corporation Class B" },
  { symbol: "NWSA", name: "News Corporation Class A" },
  { symbol: "NXPI", name: "NXP Semiconductors N.V." },
  { symbol: "O", name: "Realty Income Corporation" },
  { symbol: "ODFL", name: "Old Dominion Freight Line Inc." },
  { symbol: "OKE", name: "ONEOK Inc." },
  { symbol: "OMC", name: "Omnicom Group Inc." },
  { symbol: "ON", name: "ON Semiconductor Corporation" },
  { symbol: "ORCL", name: "Oracle Corporation" },
  { symbol: "ORLY", name: "O'Reilly Automotive Inc." },
  { symbol: "OTIS", name: "Otis Worldwide Corporation" },
  { symbol: "OXY", name: "Occidental Petroleum Corporation" },
  { symbol: "PANW", name: "Palo Alto Networks Inc." },
  { symbol: "PARA", name: "Paramount Global" },
  { symbol: "PAYC", name: "Paycom Software Inc." },
  { symbol: "PAYX", name: "Paychex Inc." },
  { symbol: "PCAR", name: "PACCAR Inc." },
  { symbol: "PCG", name: "PG&E Corporation" },
  { symbol: "PEG", name: "Public Service Enterprise Group Incorporated" },
  { symbol: "PEP", name: "PepsiCo Inc." },
  { symbol: "PFE", name: "Pfizer Inc." },
  { symbol: "PFG", name: "Principal Financial Group Inc." },
  { symbol: "PG", name: "Procter & Gamble Company" },
  { symbol: "PGR", name: "Progressive Corporation" },
  { symbol: "PH", name: "Parker-Hannifin Corporation" },
  { symbol: "PHM", name: "PulteGroup Inc." },
  { symbol: "PKG", name: "Packaging Corporation of America" },
  { symbol: "PLD", name: "Prologis Inc." },
  { symbol: "PLTR", name: "Palantir Technologies Inc." },
  { symbol: "PM", name: "Philip Morris International Inc." },
  { symbol: "PNC", name: "PNC Financial Services Group Inc." },
  { symbol: "PNR", name: "Pentair plc" },
  { symbol: "PNW", name: "Pinnacle West Capital Corporation" },
  { symbol: "PODD", name: "Insulet Corporation" },
  { symbol: "POOL", name: "Pool Corporation" },
  { symbol: "PPG", name: "PPG Industries Inc." },
  { symbol: "PPL", name: "PPL Corporation" },
  { symbol: "PRU", name: "Prudential Financial Inc." },
  { symbol: "PSA", name: "Public Storage" },
  { symbol: "PSX", name: "Phillips 66" },
  { symbol: "PTC", name: "PTC Inc." },
  { symbol: "PWR", name: "Quanta Services Inc." },
  { symbol: "PYPL", name: "PayPal Holdings Inc." },
  { symbol: "QCOM", name: "QUALCOMM Incorporated" },
  { symbol: "QRVO", name: "Qorvo Inc." },
  { symbol: "RCL", name: "Royal Caribbean Cruises Ltd." },
  { symbol: "REG", name: "Regency Centers Corporation" },
  { symbol: "REGN", name: "Regeneron Pharmaceuticals Inc." },
  { symbol: "RF", name: "Regions Financial Corporation" },
  { symbol: "RHI", name: "Robert Half Inc." },
  { symbol: "RJF", name: "Raymond James Financial Inc." },
  { symbol: "RL", name: "Ralph Lauren Corporation" },
  { symbol: "RMD", name: "ResMed Inc." },
  { symbol: "ROK", name: "Rockwell Automation Inc." },
  { symbol: "ROL", name: "Rollins Inc." },
  { symbol: "ROP", name: "Roper Technologies Inc." },
  { symbol: "ROST", name: "Ross Stores Inc." },
  { symbol: "RSG", name: "Republic Services Inc." },
  { symbol: "RTX", name: "RTX Corporation" },
  { symbol: "RVTY", name: "Revvity Inc." },
  { symbol: "SBAC", name: "SBA Communications Corporation" },
  { symbol: "SBUX", name: "Starbucks Corporation" },
  { symbol: "SCHW", name: "Charles Schwab Corporation" },
  { symbol: "SHW", name: "Sherwin-Williams Company" },
  { symbol: "SJM", name: "J.M. Smucker Company" },
  { symbol: "SLB", name: "SLB" },
  { symbol: "SMCI", name: "Super Micro Computer Inc." },
  { symbol: "SNA", name: "Snap-on Incorporated" },
  { symbol: "SNPS", name: "Synopsys Inc." },
  { symbol: "SO", name: "Southern Company" },
  { symbol: "SPG", name: "Simon Property Group Inc." },
  { symbol: "SPGI", name: "S&P Global Inc." },
  { symbol: "SRE", name: "Sempra" },
  { symbol: "STE", name: "STERIS plc" },
  { symbol: "STLD", name: "Steel Dynamics Inc." },
  { symbol: "STT", name: "State Street Corporation" },
  { symbol: "STX", name: "Seagate Technology Holdings plc" },
  { symbol: "STZ", name: "Constellation Brands Inc." },
  { symbol: "SWK", name: "Stanley Black & Decker Inc." },
  { symbol: "SWKS", name: "Skyworks Solutions Inc." },
  { symbol: "SYF", name: "Synchrony Financial" },
  { symbol: "SYK", name: "Stryker Corporation" },
  { symbol: "SYY", name: "Sysco Corporation" },
  { symbol: "T", name: "AT&T Inc." },
  { symbol: "TAP", name: "Molson Coors Beverage Company" },
  { symbol: "TDG", name: "TransDigm Group Incorporated" },
  { symbol: "TDY", name: "Teledyne Technologies Incorporated" },
  { symbol: "TECH", name: "Bio-Techne Corporation" },
  { symbol: "TEL", name: "TE Connectivity Ltd." },
  { symbol: "TER", name: "Teradyne Inc." },
  { symbol: "TFC", name: "Truist Financial Corporation" },
  { symbol: "TFX", name: "Teleflex Incorporated" },
  { symbol: "TGT", name: "Target Corporation" },
  { symbol: "TJX", name: "TJX Companies Inc." },
  { symbol: "TMO", name: "Thermo Fisher Scientific Inc." },
  { symbol: "TMUS", name: "T-Mobile US Inc." },
  { symbol: "TPR", name: "Tapestry Inc." },
  { symbol: "TRGP", name: "Targa Resources Corp." },
  { symbol: "TRMB", name: "Trimble Inc." },
  { symbol: "TROW", name: "T. Rowe Price Group Inc." },
  { symbol: "TRV", name: "Travelers Companies Inc." },
  { symbol: "TSCO", name: "Tractor Supply Company" },
  { symbol: "TSLA", name: "Tesla Inc." },
  { symbol: "TSN", name: "Tyson Foods Inc." },
  { symbol: "TT", name: "Trane Technologies plc" },
  { symbol: "TTWO", name: "Take-Two Interactive Software Inc." },
  { symbol: "TXN", name: "Texas Instruments Incorporated" },
  { symbol: "TXT", name: "Textron Inc." },
  { symbol: "TYL", name: "Tyler Technologies Inc." },
  { symbol: "UAL", name: "United Airlines Holdings Inc." },
  { symbol: "UBER", name: "Uber Technologies Inc." },
  { symbol: "UDR", name: "UDR Inc." },
  { symbol: "UHS", name: "Universal Health Services Inc." },
  { symbol: "ULTA", name: "Ulta Beauty Inc." },
  { symbol: "UNH", name: "UnitedHealth Group Incorporated" },
  { symbol: "UNP", name: "Union Pacific Corporation" },
  { symbol: "UPS", name: "United Parcel Service Inc." },
  { symbol: "URI", name: "United Rentals Inc." },
  { symbol: "USB", name: "U.S. Bancorp" },
  { symbol: "V", name: "Visa Inc." },
  { symbol: "VICI", name: "VICI Properties Inc." },
  { symbol: "VLO", name: "Valero Energy Corporation" },
  { symbol: "VLTO", name: "Veralto Corporation" },
  { symbol: "VMC", name: "Vulcan Materials Company" },
  { symbol: "VMRK", name: "Vivmark Residential Inc." },
  { symbol: "VRSK", name: "Verisk Analytics Inc." },
  { symbol: "VRSN", name: "VeriSign Inc." },
  { symbol: "VRTX", name: "Vertex Pharmaceuticals Incorporated" },
  { symbol: "VST", name: "Vistra Corp." },
  { symbol: "VTR", name: "Ventas Inc." },
  { symbol: "VTRS", name: "Viatris Inc." },
  { symbol: "VZ", name: "Verizon Communications Inc." },
  { symbol: "WAB", name: "Westinghouse Air Brake Technologies Corporation" },
  { symbol: "WAT", name: "Waters Corporation" },
  { symbol: "WBD", name: "Warner Bros. Discovery Inc." },
  { symbol: "WDC", name: "Western Digital Corporation" },
  { symbol: "WEC", name: "WEC Energy Group Inc." },
  { symbol: "WELL", name: "Welltower Inc." },
  { symbol: "WFC", name: "Wells Fargo & Company" },
  { symbol: "WM", name: "Waste Management Inc." },
  { symbol: "WMB", name: "Williams Companies Inc." },
  { symbol: "WMT", name: "Walmart Inc." },
  { symbol: "WRB", name: "W. R. Berkley Corporation" },
  { symbol: "WST", name: "West Pharmaceutical Services Inc." },
  { symbol: "WTW", name: "Willis Towers Watson Public Limited Company" },
  { symbol: "WY", name: "Weyerhaeuser Company" },
  { symbol: "WYNN", name: "Wynn Resorts Limited" },
  { symbol: "XEL", name: "Xcel Energy Inc." },
  { symbol: "XOM", name: "Exxon Mobil Corporation" },
  { symbol: "XYL", name: "Xylem Inc." },
  { symbol: "YUM", name: "Yum! Brands Inc." },
  { symbol: "ZBH", name: "Zimmer Biomet Holdings Inc." },
  { symbol: "ZBRA", name: "Zebra Technologies Corporation" },
  { symbol: "ZTS", name: "Zoetis Inc." }
];

// Legacy export for backward compatibility - returns just symbols
export const SP500_SYMBOLS = SYMBOL_DATA.map(s => s.symbol);

export const INTERVALS = [
  { value: "1m", label: "1 Minute" },
  { value: "5m", label: "5 Minutes" },
  { value: "15m", label: "15 Minutes" },
  { value: "30m", label: "30 Minutes" },
  { value: "1h", label: "1 Hour" },
  { value: "1d", label: "1 Day" }
];

export const PERIODS = [
  { value: "1d", label: "1 Day" },
  { value: "5d", label: "5 Days" },
  { value: "10d", label: "10 Days" },
  { value: "15d", label: "15 Days" },
  { value: "20d", label: "20 Days" },
  { value: "1mo", label: "1 Month" },
  { value: "3mo", label: "3 Months" },
  { value: "6mo", label: "6 Months" },
  { value: "1y", label: "1 Year" }
];
